import { render, staticRenderFns } from "./RecursosGrupoUsuario.vue?vue&type=template&id=2bd7c892&scoped=true"
import script from "./RecursosGrupoUsuario.vue?vue&type=script&lang=js"
export * from "./RecursosGrupoUsuario.vue?vue&type=script&lang=js"
import style0 from "./RecursosGrupoUsuario.vue?vue&type=style&index=0&id=2bd7c892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd7c892",
  null
  
)

export default component.exports